module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_hogar90.a1a24695.jpg";